import cookie from "react-cookies";
import { set_bcz_internal_token, get_bcz_internal_token } from "./Session";
import { frontUrl } from "./GetUrl";

let bcz_internal_token = get_bcz_internal_token();

export function request(url, method) {
    const params = {
        method: method,
        credentials: "include",
        headers: {
            "bcz-internal-token": cookie.load("bcz_internal_token") == null ? "null" : cookie.load("bcz_internal_token")
        },
    }
    return fetch_process(url, params);
}

export function request_post(url, data) {
    const params = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "bcz-internal-token": cookie.load("bcz_internal_token") == null ? "null" : cookie.load("bcz_internal_token")
        },
        credentials: "include",
        body: JSON.stringify(data)
    }
    return fetch_process(url, params);
}

export function request_delete(url, content_type, body) {
    const params = {
        method: "DELETE",
        headers: {
            "Content-Type": content_type,
            "bcz-internal-token": cookie.load("bcz_internal_token") == null ? "null" : cookie.load("bcz_internal_token")
        },
        credentials: "include",
        body: body
    }
    return fetch_process(url, params);
}

export function request_put(url, content_type, body) {
    const params = {
        method: "PUT",
        headers: {
            "Content-Type": content_type,
            "bcz-internal-token": cookie.load("bcz_internal_token") == null ? "null" : cookie.load("bcz_internal_token")
        },
        credentials: "include",
        body: body
    }
    return fetch_process(url, params);
}

function fetch_process(url, params) {
    let cnName = cookie.load("cnName");
    let userId = cookie.load("userId");
    // 默认分组为商城
    let groupId = cookie.load("groupId") == null ? 0 : cookie.load("groupId");
    let groupName = cookie.load("groupName") == null ? "商城" : cookie.load("groupName");
    let location_url = window.location.href;
    return fetch(url, params).then(res => {
        if (res.status == 403 || cnName == null || userId == null || groupId == null || groupName == null) { // 如果返回状态码是403或者cnName，userId，groupId，groupName任意为null
            clearCookie();
            setTimeout(()=>{
                window.location.href = "https://cyamis.baicizhan.com/home/scan_to_login_weixin?redirect=" + encodeURI(frontUrl + "/home/login?redirectUrl=" + location_url) + "&auth_type=silence";
            }, 1000);
            return;
        }
        return res;
    });
}

function clearCookie(){
    cookie.remove("groupId", { path: "/" });
    cookie.remove("cnName", { path: "/" });
    cookie.remove("userId", { path: "/" });
    cookie.remove("groupName", { path: "/" });
    cookie.remove("role", { path: "/" });
    cookie.remove("bcz_internal_token", { path: "/" });
    cookie.remove("bcz_internal_token", { path: "/home" });
    cookie.remove("isLogin", { path: "/" });
}
function getBrowserInfo() {
    var agent = navigator.userAgent.toLowerCase();
    var regStr_ie = /msie [\d.]+;/gi;
    var regStr_ff = /firefox\/[\d.]+/gi
    var regStr_chrome = /chrome\/[\d.]+/gi;
    var regStr_saf = /safari\/[\d.]+/gi;
    var regStr_wechat = /wechat\/[\d.]+/gi;

    //IE
    if (agent.indexOf("msie") > 0) {
        return agent.match(regStr_ie);
    }

    //firefox
    if (agent.indexOf("firefox") > 0) {
        return agent.match(regStr_ff);
    }

    //Safari
    if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {
        return agent.match(regStr_saf);
    }

    //Chrome
    if (agent.indexOf("chrome") > 0) {
        return agent.match(regStr_chrome);
    }

    //WeChat
    if (agent.indexOf("wechat") > 0) {
        return agent.match(regStr_wechat);
    }
}


// WEBPACK FOOTER //
// ./src/utils/request.js